module.exports = __webpack_public_path__ + "static/media/cardThird.238768f1.svg";